import { createFileRoute } from '@tanstack/react-router'
import { myOrgInternSearchSchema } from '@/features/my-org-interns/filter-my-org-interns/model/myOrgInternSearch'
import { MyOrgInternsPage } from '@/pages/internships/ui/MyOrgInternsPage'

export const Route = createFileRoute('/my-org-interns')({
  validateSearch: myOrgInternSearchSchema,
  component: MyOrgInternsPage,
})
